import { useEffect, useState } from "react";
import axios from "axios";
import { sidebarAd } from "../pages/home/sidebarData";
import { getMediaBaseUrl } from "../utils/backendUrl";

const AdBanner = ({ className = "" }) => {
  const [adItems, setAdItems] = useState([]);
  const [adIndex, setAdIndex] = useState(0);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}message`
        );
        setAdItems(res.data || []);
        setAdIndex(0);
      } catch (err) {
        console.error("Failed to fetch ads", err);
        setAdItems([]);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    if (adItems.length <= 1) return;
    const intervalId = setInterval(() => {
      setAdIndex((prev) => (prev + 1) % adItems.length);
    }, 8000);
    return () => clearInterval(intervalId);
  }, [adItems.length]);

  const baseUrl = getMediaBaseUrl();
  const current = adItems[adIndex];
  const image = current?.image
    ? `${baseUrl}/uploads/messages/${current.image}`
    : sidebarAd.image;
  const alt = current?.title || sidebarAd.alt;
  const link = "/ad";

  return (
    <div className={`bg-rich-black border-zinc-800 rounded-lg border shadow-sm overflow-hidden p-1 ${className}`}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
      >
        <img
          src={image}
          alt={alt}
          className="w-full h-full object-contain bg-rich-black border-zinc-800 rounded hover:opacity-95 transition"
        />
      </a>
    </div>
  );
};

export default AdBanner;
